import Sp3Module from '@terra-js/sp3-module';
import TerraKit from '@terra-js/terra-kit';
import '@terra-js/web-bridge';
import { browserHistory } from 'helpers';
import TekoID from 'teko-oauth2';

const isLoggedIn = async () => {
  if (TerraKit.isAvailable()) {
    const result = await Sp3Module.isLoggedIn();
    if (result.isSuccess()) {
      return result.getValue();
    }
    return false;
  }
  return TekoID.user.isLoggedIn();
};

const login = () => {
  if (TerraKit.isAvailable()) {
    Sp3Module.logOut();
    return;
  }
  TekoID.user.login();
};

const logout = () => {
  // Tracking - Reset userId when logged out
  track('resetUserId');
  if (!TerraKit.isAvailable()) {
    TekoID.user.logout(window.location.origin);
    localStorage.removeItem('DISPLAY_OPTIONS');
    return;
  }
  Sp3Module.logOut();
};

const getAccessToken = async () => {
  if (!TerraKit.isAvailable()) {
    return TekoID.user.getAccessToken();
  }
  return await TerraKit.auth().getAccessTokenAsync();
};

const getUserInfo = () => {
  return TekoID.user.getUserInfo();
};

const getFullUserInfo = async (): Promise<any> => {
  if (TerraKit.isAvailable()) {
    const result = await TerraKit.auth().getFullUserInfo();
    if (result) {
      return { ...result, meta_data: result.metadata };
    }
    return undefined;
  }
  const fullUserInfo = await TekoID.user.getFullUserInfo();
  return fullUserInfo;
};

const denyAccess = () => {
  browserHistory.push('/403');
};

export default {
  isLoggedIn,
  login,
  logout,
  getAccessToken,
  getUserInfo,
  getFullUserInfo,
  denyAccess,
};
